import { Link, NavLink, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AdminEvaluation from './pages/AdminEvaluation';
import AdminInterviewers from './pages/AdminInterviewers';
import AdminJobDetail from './pages/AdminJobDetail';
import AdminJobNew from './pages/AdminJobNew';
import AdminNew from './pages/AdminNew';
import AdminInterviewList from './pages/AdminInterviewList';
import AdminJobList from './pages/AdminJobList';
import AdminAccount from './pages/AdminAccount';
import Login from './pages/Login';
import PreCheck from './pages/PreCheck';
import InterviewRoom from './pages/InterviewRoom';
import Ended from './pages/Ended';
import MediaDiag from './pages/MediaDiag';
import { AuthProvider, useAuth } from './lib/AuthContext';
import { SettingsMenu } from './components/SettingsMenu';
import type { ReactNode } from 'react';

function ProtectedRoute({ children }: { children: ReactNode }) {
  const { tenant, loading } = useAuth();
  if (loading) return <div className="container"><p className="hint">加载中...</p></div>;
  if (!tenant) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function Nav() {
  const { tenant } = useAuth();
  const loc = useLocation();
  if (loc.pathname.startsWith('/login') ||
      loc.pathname.startsWith('/interview/')) return null;
  return (
    <nav className="nav">
      <Link to="/" className="brand">🎯 AI 招聘智能体</Link>
      {tenant && (
        <>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>工作台</NavLink>
          <div className="spacer" />
          <SettingsMenu />
        </>
      )}
    </nav>
  );
}

function AppRoutes() {
  return (
    <>
      <Nav />
      <Routes>
        {/* 公开页 */}
        <Route path="/login" element={<Login />} />
        <Route path="/interview/:token" element={<PreCheck />} />
        <Route path="/interview/:token/room" element={<InterviewRoom />} />
        <Route path="/interview/:token/ended" element={<Ended />} />
        <Route path="/diag" element={<MediaDiag />} />

        {/* HR 受保护 */}
        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><Home /></ProtectedRoute>} />

        {/* 招聘需求 */}
        <Route path="/admin/jobs" element={<ProtectedRoute><AdminJobList /></ProtectedRoute>} />
        <Route path="/admin/jobs/new" element={<ProtectedRoute><AdminJobNew /></ProtectedRoute>} />
        <Route path="/admin/job/:id" element={<ProtectedRoute><AdminJobDetail /></ProtectedRoute>} />

        {/* 面试 */}
        <Route path="/admin/interviews" element={<ProtectedRoute><AdminInterviewList /></ProtectedRoute>} />
        <Route path="/admin/new" element={<ProtectedRoute><AdminNew /></ProtectedRoute>} />
        <Route path="/admin/interview/:id" element={<ProtectedRoute><AdminEvaluation /></ProtectedRoute>} />

        {/* 设置 */}
        <Route path="/admin/settings/interviewers" element={<ProtectedRoute><AdminInterviewers /></ProtectedRoute>} />
        <Route path="/admin/settings/account" element={<ProtectedRoute><AdminAccount /></ProtectedRoute>} />
        {/* 兼容老链接 */}
        <Route path="/admin/interviewers" element={<Navigate to="/admin/settings/interviewers" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
